unit diesel.fuelorders.enquiry;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.Buttons, WEBLib.DBCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, VCL.TMSFNCCustomComponent, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  XData.Web.Client, Vcl.Imaging.GIFImg, WEBLib.TMSWEBCustomComponent,
  WEBLib.TMSWEBStateManager, WEBLib.TMSWEBResponsiveManager, WEBLib.ComCtrls,
  System.Rtti, VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData,
  VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCDataGrid, WebLib.JSON, System.DateUtils;

type
  TfrmFuelOrders = class(TForm)
    webconnect: TXDataWebClient;
    qInfo: TXDataWebDataSet;
    dsInfo: TDataSource;
    MessageDlg: TMessageDlg;
    WebTimer1: TTimer;
    qInfoOrderNo: TIntegerField;
    qInfoOrderDate: TDateField;
    qInfoRegNo: TStringField;
    qInfoDepotCode: TIntegerField;
    qInfoDepotName: TStringField;
    qInfoSubCode: TStringField;
    qInfoSubName: TStringField;
    qInfoFleetNo: TStringField;
    qInfoOrderLiters: TFloatField;
    qInfoInvoicedLiters: TFloatField;
    qInfoCanceled: TBooleanField;
    qInfoCInvoiced: TBooleanField;
    qInfoSInvoiced: TBooleanField;
    qInfoSupplierCode: TStringField;
    qInfoSupplierName: TStringField;
    qInfoSOrderNo: TStringField;
    qInfoSInvoiceNo: TStringField;
    qInfoOrderPrice: TFloatField;
    qInfoOrderAmount: TFloatField;
    qInfoFillType: TBooleanField;
    qStatus: TXDataWebDataSet;
    qStatusOrderNo: TIntegerField;
    qStatusValid: TBooleanField;
    qStatusSystemMessage: TStringField;
    qInfoInProgress: TBooleanField;
    WebPanel2: TPanel;
    WebScrollBox1: TScrollBox;
    WebPanel1: TPanel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    eSubsCompany: TEdit;
    btnSearchSubs: TSpeedButton;
    wdpStart: TDateTimePicker;
    wdpEnd: TDateTimePicker;
    btnSearch: TSpeedButton;
    WebLabel5: TLabel;
    eRegNo: TEdit;
    btnRegNo: TSpeedButton;
    wpBottom: TPanel;
    ePages: TEdit;
    btnFirst: TSpeedButton;
    btnNext: TSpeedButton;
    btnPrior: TSpeedButton;
    btnLast: TSpeedButton;
    gEnquiry: TTMSFNCDataGrid;
    gdaEnquiry: TTMSFNCDataGridDatabaseAdapter;
    btnNew: TSpeedButton;
    btnClose: TSpeedButton;
    cbShowInvoiced: TCheckBox;
    cbShowCancel: TCheckBox;
    WebLabel1: TLabel;
    eDepot: TEdit;
    btnSearchDepot: TSpeedButton;
    procedure btnSearchClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebTimer1Timer(Sender: TObject);
    procedure btnNewClick(Sender: TObject);
    procedure btnEditClick(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure eSubsCompanyKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btnSearchSubsClick(Sender: TObject);
    procedure qInfoAfterOpen(DataSet: TDataSet);
    procedure eRegNoKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure btnRegNoClick(Sender: TObject);
    procedure btnFirstClick(Sender: TObject);
    procedure btnPriorClick(Sender: TObject);
    procedure btnNextClick(Sender: TObject);
    procedure btnLastClick(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
    procedure gEnquiryGetCellFormatting(Sender: TObject;
      ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
      var AFormatting: TTMSFNCDataGridDataFormatting;
      var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
    procedure btnSearchDepotClick(Sender: TObject);
  private
    { Private declarations }
    procedure LoadData;
    procedure StartLoadData;
    procedure UpdatePageButtons;
  public
    { Public declarations }
    username : String;
    iSystemType,
    iPageNo,
    iPageCount : Integer;
    sCompany,
    sRegNo : String;
    bAllowSearchChange : Boolean;
  protected procedure LoadDFMValues; override; end;

var
  frmFuelOrders: TfrmFuelOrders;

implementation

{$R *.dfm}

Uses
  stfmssystem.connection,
  share.classes,
  diesel.fuelorders.create,
  search.subsdiesel,
  search.reg,
  share.common;

procedure TfrmFuelOrders.btnCancelClick(Sender: TObject);
  procedure OnResultCreate(Response : TXDataClientResponse);
  begin
    try
      qStatus.Close;
      qStatus.SetJsonData(Response.Result);
      qStatus.Open;

      If not qStatus.FieldByName('Valid').asBoolean then
        MessageDlg.ShowDialog(qStatus.FieldByName('SystemMessage').asString, WEBLib.Dialogs.mtError, [mbOk])
      else
        StartLoadData;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;

begin
  webConnect.RawInvoke('IstfmssubsService.CancelDieselOrderDepot',
                       [qInfo.FieldByName('OrderNo').asInteger,iSystemType],@OnResultCreate);
end;

procedure TfrmFuelOrders.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmFuelOrders.btnEditClick(Sender: TObject);
  var
    LFrm : TfrmCreateDieselOrders;
  procedure AfterCreate(AForm : TObject);
  begin
    (AForm as TfrmCreateDieselOrders).UserName := UserName;
    (AForm as TfrmCreateDieselOrders).bInsert := False;
    (AForm as TfrmCreateDieselOrders).iOrderNo := qInfo.FieldByName('OrderNo').AsInteger;
    (AForm as TfrmCreateDieselOrders).sSubs := sCompany;
    (AForm as TfrmCreateDieselOrders).iSystemType := iSystemType;
  end;
begin
  LFrm := TfrmCreateDieselOrders.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal;
end;

procedure TfrmFuelOrders.btnFirstClick(Sender: TObject);
begin
  iPageNo := 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmFuelOrders.btnLastClick(Sender: TObject);
begin
  iPageNo := iPageCount;
  UpdatePageButtons;
  LoadData
end;

procedure TfrmFuelOrders.btnNewClick(Sender: TObject);
  var
    LFrm : TfrmCreateDieselOrders;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    StartLoadData;
  end;
  procedure AfterCreate(AForm : TObject);
  begin
    (AForm as TfrmCreateDieselOrders).UserName := UserName;
    (AForm as TfrmCreateDieselOrders).bInsert := True;
    (AForm as TfrmCreateDieselOrders).iOrderNo := -1;
    Case iSystemType of
      0 : begin
            if bAllowSearchChange then
              begin
                (AForm as TfrmCreateDieselOrders).sSubs := '*';
                (AForm as TfrmCreateDieselOrders).lCompany.Text := '';
                (AForm as TfrmCreateDieselOrders).sRegNo := '*';
                (AForm as TfrmCreateDieselOrders).lRegNo.Text := '';
                (AForm as TfrmCreateDieselOrders).bForceReg := False;
                (AForm as TfrmCreateDieselOrders).bForceComp := False;
              end
            else
              begin
                if sCompany = '' then
                  begin
                    (AForm as TfrmCreateDieselOrders).sSubs := '*';
                    (AForm as TfrmCreateDieselOrders).lCompany.Text := '';
                    (AForm as TfrmCreateDieselOrders).bForceComp := False;
                  end
                else
                  begin
                    (AForm as TfrmCreateDieselOrders).sSubs := sCompany;
                    (AForm as TfrmCreateDieselOrders).lCompany.Text := eSubsCompany.Text;
                    (AForm as TfrmCreateDieselOrders).bForceComp := True;
                  end;
                if sRegNo = '' then
                  begin
                    (AForm as TfrmCreateDieselOrders).sRegNo := '*';
                    (AForm as TfrmCreateDieselOrders).lRegNo.Text := '';
                    (AForm as TfrmCreateDieselOrders).bForceReg := False;
                  end
                else
                  begin
                    (AForm as TfrmCreateDieselOrders).sRegNo := sRegNo;
                    (AForm as TfrmCreateDieselOrders).lRegNo.Text := eRegNo.Text;
                    (AForm as TfrmCreateDieselOrders).bForceReg := True;
                  end;
              end;
          end;
      1 : begin
            (AForm as TfrmCreateDieselOrders).sSubs := sCompany;
            (AForm as TfrmCreateDieselOrders).lCompany.Text := eSubsCompany.Text;
            if Trim(sCompany) = '' then
              (AForm as TfrmCreateDieselOrders).bForceComp := False
            else
              (AForm as TfrmCreateDieselOrders).bForceComp := True;
            (AForm as TfrmCreateDieselOrders).sRegNo := '*';
            (AForm as TfrmCreateDieselOrders).bForceReg := False;
          end;
    End;
    (AForm as TfrmCreateDieselOrders).iSystemType := iSystemType;
  end;
begin
  LFrm := TfrmCreateDieselOrders.CreateNew( @AfterCreate );
  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.btnNextClick(Sender: TObject);
begin
  iPageNo := iPageNo + 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmFuelOrders.btnPriorClick(Sender: TObject);
begin
  iPageNo := iPageNo - 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmFuelOrders.btnRegNoClick(Sender: TObject);
  var
    LFrm : TfrmSearchReg;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            eRegNo.Text := sName;
            sRegNo := sCode;
          end
        else
          begin
            eRegNo.Text := '';
            sRegNo := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchReg) do
      begin
        bSuspended := True;
        iType := iSystemType;
        if UserName = '*' then
          sController := '*'
        else
          sController := UserName;
        if sCompany = '' then
          sSearchSub := '*'
        else
          sSearchSub := sCompany;
        GetData;
      end;
  end;
begin
  LFrm := TfrmSearchReg.CreateNew( @AfterCreate );

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.btnSearchClick(Sender: TObject);
begin
  StartLoadData;
end;

procedure TfrmFuelOrders.btnSearchDepotClick(Sender: TObject);
  var
    LFrm : TfrmSearchSubsDiesel;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            eSubsCompany.Text := sName;
            sCompany := sCode;
          end
        else
          begin
            eSubsCompany.Text := '';
            sCompany := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchSubsDiesel) do
      begin
        bSuspended := True;
        iType := iSystemType;
        sUserName := UserName;
        GetData;

      end;
  end;
begin
  LFrm := TfrmSearchSubsDiesel.CreateNew( @AfterCreate );

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.btnSearchSubsClick(Sender: TObject);
  var
    LFrm : TfrmSearchSubsDiesel;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if sCode <> '' then
          begin
            eSubsCompany.Text := sName;
            sCompany := sCode;
          end
        else
          begin
            eSubsCompany.Text := '';
            sCompany := '';
          end;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmSearchSubsDiesel) do
      begin
        bSuspended := True;
        iType := iSystemType;
        sUserName := UserName;
        GetData;

      end;
  end;
begin
  LFrm := TfrmSearchSubsDiesel.CreateNew( @AfterCreate );

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmFuelOrders.eRegNoKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      eRegNo.Text := '';
      sRegNo := '';
    end;
end;

procedure TfrmFuelOrders.eSubsCompanyKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if Key = VK_Delete then
    begin
      eSubsCompany.Text := '';
      sCompany := '';
    end;
end;

procedure TfrmFuelOrders.gEnquiryGetCellFormatting(Sender: TObject;
  ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
  var AFormatting: TTMSFNCDataGridDataFormatting;
  var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
begin
  //if (ARow >= gInfo.FixedRows) then
    //begin
      //if dsInfo.DataSet.FieldByName('InProgress').asBoolean then
        //ALayout.Fill.Color := gcYellow;
    //end;
end;

procedure TfrmFuelOrders.LoadData;
  var
    GetDieselEnquiryDetail : TGetDieselEnquiryDetail;
    jo: TJSONObject;
    jString : String;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadData;
  end;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      qInfo.Close;
      qInfo.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      qInfo.Open;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  //WebWaitMessage1.Show;

  GetDieselEnquiryDetail := TGetDieselEnquiryDetail.Create;
  if Username = '' then
    GetDieselEnquiryDetail.Controller := '*'
  else
    GetDieselEnquiryDetail.Controller := Username;

  if Trim(sCompany) = '' then
    GetDieselEnquiryDetail.SubCode := '*'
  else
    GetDieselEnquiryDetail.SubCode := sCompany;

  if sRegNo = '' then
    GetDieselEnquiryDetail.RegNo := '*'
  else
    GetDieselEnquiryDetail.RegNo := sRegNo;
  GetDieselEnquiryDetail.StartDate := DateToISO8601(wdpStart.Date);
  GetDieselEnquiryDetail.EndDate := DateToISO8601(wdpEnd.Date);
  GetDieselEnquiryDetail.DepotCode := -1;
  GetDieselEnquiryDetail.Cancelled := false;
  GetDieselEnquiryDetail.Invoiced := false;
  GetDieselEnquiryDetail.SystemType := iSystemType;
  GetDieselEnquiryDetail.PageCount := iPageNo;
  jo := ConvertObjToJson(GetDieselEnquiryDetail);
  jString := jo.ToJSON;
  GetDieselEnquiryDetail.Free;
  jo.Free;
  webConnect.RawInvoke('IstfmsdieselService.GetDieselOrders',
                       [jString],@OnResultSummary,@OnError);
end;

procedure TfrmFuelOrders.qInfoAfterOpen(DataSet: TDataSet);
begin
  TFloatField(qInfo.FieldByName('orderliters')).DisplayFormat := '#,##0.00';
  TFloatField(qInfo.FieldByName('orderprice')).DisplayFormat := '#,##0.00';
  TFloatField(qInfo.FieldByName('orderamount')).DisplayFormat := '#,##0.00';
  TDateField(qInfo.FieldByName('orderdate')).DisplayFormat := 'dd/MM/yyyy';
  {if WebWaitMessage1.Visible then
    WebWaitMessage1.Hide;}
  
end;

procedure TfrmFuelOrders.StartLoadData;
  var
    GetDieselEnquiryPageCount : TGetDieselEnquiryPageCount;
    jo: TJSONObject;
    jStr : String;
  procedure OnError(Error: TXDataClientError);
  begin
    StartLoadData;
  end;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      iPageCount := JS.ToInteger(JS.ToObject(Response.Result)['value']);
      iPageNo := 1;

      UpdatePageButtons;

      LoadData;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  //WebWaitMessage1.Show;

  GetDieselEnquiryPageCount := TGetDieselEnquiryPageCount.Create;
  if Username = '' then
    GetDieselEnquiryPageCount.Controller := '*'
  else
    GetDieselEnquiryPageCount.Controller := Username;

  if Trim(sCompany) = '' then
    GetDieselEnquiryPageCount.SubCode := '*'
  else
    GetDieselEnquiryPageCount.SubCode := sCompany;

  if sRegNo = '' then
    GetDieselEnquiryPageCount.RegNo := '*'
  else
    GetDieselEnquiryPageCount.RegNo := sRegNo;
  GetDieselEnquiryPageCount.StartDate := DateToISO8601(wdpStart.Date);
  GetDieselEnquiryPageCount.EndDate := DateToISO8601(wdpEnd.Date);
  GetDieselEnquiryPageCount.DepotCode := -1;
  GetDieselEnquiryPageCount.Cancelled := cbShowCancel.Checked;
  GetDieselEnquiryPageCount.Invoiced := cbShowInvoiced.Checked;
  GetDieselEnquiryPageCount.SystemType := iSystemType;
  jo := ConvertObjToJson(GetDieselEnquiryPageCount);
  jStr := jo.ToJson;
  jo.Free;
  GetDieselEnquiryPageCount.Free;
  webConnect.RawInvoke('IstfmsdieselService.GetDieselOrdersPageCount',
                       [jStr],@OnResultSummary,@OnError);

end;

procedure TfrmFuelOrders.UpdatePageButtons;
begin
  ePages.Text := IntToStr(iPageNo) + ' of ' + IntToStr(iPageCount);
  if iPageNo > 1 then
    begin
      btnFirst.Enabled := True;
      btnPrior.Enabled := True;
    end
  else
    begin
      btnFirst.Enabled := False;
      btnPrior.Enabled := False;
    end;
  if (iPageCount > 1) and (iPageNo < iPageCount) then
    begin
      btnNext.Enabled := True;
      btnLast.Enabled := True;
    end
  else
    begin
      btnNext.Enabled := False;
      btnLast.Enabled := False;
    end;
end;

procedure TfrmFuelOrders.WebFormShow(Sender: TObject);
  var
    wYear,
    wMonth,
    wDay : Word;
begin
  DecodeDate(Date,wYear,wMonth,wDay);
  wdpStart.Date := EncodeDate(wYear,wMonth,1);
  wdpEnd.Date := Date;

  If iSystemType = 0 then
    bAllowSearchChange := True
  else
    bAllowSearchChange := False;

  btnSearchSubs.Enabled := bAllowSearchChange;
  eSubsCompany.Enabled := bAllowSearchChange;
  btnRegNo.Enabled := bAllowSearchChange;
  eRegNo.Enabled := bAllowSearchChange;

  StartLoadData;
end;

procedure TfrmFuelOrders.WebTimer1Timer(Sender: TObject);
begin
  StartLoadData;
end;

procedure TfrmFuelOrders.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MessageDlg := TMessageDlg.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  eSubsCompany := TEdit.Create(Self);
  btnSearchSubs := TSpeedButton.Create(Self);
  wdpStart := TDateTimePicker.Create(Self);
  wdpEnd := TDateTimePicker.Create(Self);
  btnSearch := TSpeedButton.Create(Self);
  eRegNo := TEdit.Create(Self);
  btnRegNo := TSpeedButton.Create(Self);
  btnNew := TSpeedButton.Create(Self);
  btnClose := TSpeedButton.Create(Self);
  cbShowInvoiced := TCheckBox.Create(Self);
  cbShowCancel := TCheckBox.Create(Self);
  eDepot := TEdit.Create(Self);
  btnSearchDepot := TSpeedButton.Create(Self);
  wpBottom := TPanel.Create(Self);
  ePages := TEdit.Create(Self);
  btnFirst := TSpeedButton.Create(Self);
  btnNext := TSpeedButton.Create(Self);
  btnPrior := TSpeedButton.Create(Self);
  btnLast := TSpeedButton.Create(Self);
  gEnquiry := TTMSFNCDataGrid.Create(Self);
  gdaEnquiry := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  webconnect := TXDataWebClient.Create(Self);
  qInfo := TXDataWebDataSet.Create(Self);
  qInfoOrderNo := TIntegerField.Create(Self);
  qInfoOrderDate := TDateField.Create(Self);
  qInfoRegNo := TStringField.Create(Self);
  qInfoDepotCode := TIntegerField.Create(Self);
  qInfoDepotName := TStringField.Create(Self);
  qInfoSubCode := TStringField.Create(Self);
  qInfoSubName := TStringField.Create(Self);
  qInfoFleetNo := TStringField.Create(Self);
  qInfoOrderLiters := TFloatField.Create(Self);
  qInfoInvoicedLiters := TFloatField.Create(Self);
  qInfoCanceled := TBooleanField.Create(Self);
  qInfoCInvoiced := TBooleanField.Create(Self);
  qInfoSInvoiced := TBooleanField.Create(Self);
  qInfoSupplierCode := TStringField.Create(Self);
  qInfoSupplierName := TStringField.Create(Self);
  qInfoSOrderNo := TStringField.Create(Self);
  qInfoSInvoiceNo := TStringField.Create(Self);
  qInfoOrderPrice := TFloatField.Create(Self);
  qInfoOrderAmount := TFloatField.Create(Self);
  qInfoFillType := TBooleanField.Create(Self);
  qInfoInProgress := TBooleanField.Create(Self);
  dsInfo := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  qStatus := TXDataWebDataSet.Create(Self);
  qStatusOrderNo := TIntegerField.Create(Self);
  qStatusValid := TBooleanField.Create(Self);
  qStatusSystemMessage := TStringField.Create(Self);

  MessageDlg.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  eSubsCompany.BeforeLoadDFMValues;
  btnSearchSubs.BeforeLoadDFMValues;
  wdpStart.BeforeLoadDFMValues;
  wdpEnd.BeforeLoadDFMValues;
  btnSearch.BeforeLoadDFMValues;
  eRegNo.BeforeLoadDFMValues;
  btnRegNo.BeforeLoadDFMValues;
  btnNew.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  cbShowInvoiced.BeforeLoadDFMValues;
  cbShowCancel.BeforeLoadDFMValues;
  eDepot.BeforeLoadDFMValues;
  btnSearchDepot.BeforeLoadDFMValues;
  wpBottom.BeforeLoadDFMValues;
  ePages.BeforeLoadDFMValues;
  btnFirst.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  btnPrior.BeforeLoadDFMValues;
  btnLast.BeforeLoadDFMValues;
  gEnquiry.BeforeLoadDFMValues;
  gdaEnquiry.BeforeLoadDFMValues;
  webconnect.BeforeLoadDFMValues;
  qInfo.BeforeLoadDFMValues;
  qInfoOrderNo.BeforeLoadDFMValues;
  qInfoOrderDate.BeforeLoadDFMValues;
  qInfoRegNo.BeforeLoadDFMValues;
  qInfoDepotCode.BeforeLoadDFMValues;
  qInfoDepotName.BeforeLoadDFMValues;
  qInfoSubCode.BeforeLoadDFMValues;
  qInfoSubName.BeforeLoadDFMValues;
  qInfoFleetNo.BeforeLoadDFMValues;
  qInfoOrderLiters.BeforeLoadDFMValues;
  qInfoInvoicedLiters.BeforeLoadDFMValues;
  qInfoCanceled.BeforeLoadDFMValues;
  qInfoCInvoiced.BeforeLoadDFMValues;
  qInfoSInvoiced.BeforeLoadDFMValues;
  qInfoSupplierCode.BeforeLoadDFMValues;
  qInfoSupplierName.BeforeLoadDFMValues;
  qInfoSOrderNo.BeforeLoadDFMValues;
  qInfoSInvoiceNo.BeforeLoadDFMValues;
  qInfoOrderPrice.BeforeLoadDFMValues;
  qInfoOrderAmount.BeforeLoadDFMValues;
  qInfoFillType.BeforeLoadDFMValues;
  qInfoInProgress.BeforeLoadDFMValues;
  dsInfo.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  qStatus.BeforeLoadDFMValues;
  qStatusOrderNo.BeforeLoadDFMValues;
  qStatusValid.BeforeLoadDFMValues;
  qStatusSystemMessage.BeforeLoadDFMValues;
  try
    Name := 'frmFuelOrders';
    Width := 949;
    Height := 570;
    Align := alClient;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    MessageDlg.SetParentComponent(Self);
    MessageDlg.Name := 'MessageDlg';
    MessageDlg.Left := 408;
    MessageDlg.Top := 288;
    MessageDlg.Width := 24;
    MessageDlg.Height := 24;
    MessageDlg.Buttons := [mbOK];
    MessageDlg.Opacity := 0.200000000000000000;
    MessageDlg.ElementButtonClassName := 'btn';
    MessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MessageDlg.ElementTitleClassName := 'text-body';
    MessageDlg.ElementContentClassName := 'text-body';
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 949;
    WebPanel2.Height := 41;
    WebPanel2.WidthStyle := ssPercent;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Diesel Order Enquiry';
    WebPanel2.ChildOrder := 4;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -15;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 1;
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 41;
    WebScrollBox1.Width := 949;
    WebScrollBox1.Height := 528;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 11;
    WebPanel1.SetParentComponent(WebScrollBox1);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 949;
    WebPanel1.Height := 153;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 11;
    WebPanel1.TabOrder := 0;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 7;
    WebLabel2.Width := 95;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Select Company : ';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 320;
    WebLabel3.Top := 8;
    WebLabel3.Width := 107;
    WebLabel3.Height := 14;
    WebLabel3.Caption := 'Select Start Date : ';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 320;
    WebLabel4.Top := 59;
    WebLabel4.Width := 101;
    WebLabel4.Height := 14;
    WebLabel4.Caption := 'Select End Date : ';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 8;
    WebLabel5.Top := 59;
    WebLabel5.Width := 48;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Reg No : ';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 497;
    WebLabel1.Top := 7;
    WebLabel1.Width := 75;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Select Depot : ';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    eSubsCompany.SetParentComponent(WebPanel1);
    eSubsCompany.Name := 'eSubsCompany';
    eSubsCompany.Left := 8;
    eSubsCompany.Top := 28;
    eSubsCompany.Width := 254;
    eSubsCompany.Height := 22;
    eSubsCompany.ChildOrder := 8;
    eSubsCompany.HeightPercent := 100.000000000000000000;
    eSubsCompany.ReadOnly := True;
    eSubsCompany.WidthPercent := 100.000000000000000000;
    SetEvent(eSubsCompany, Self, 'OnKeyDown', 'eSubsCompanyKeyDown');
    btnSearchSubs.SetParentComponent(WebPanel1);
    btnSearchSubs.Name := 'btnSearchSubs';
    btnSearchSubs.Left := 262;
    btnSearchSubs.Top := 28;
    btnSearchSubs.Width := 24;
    btnSearchSubs.Height := 22;
    btnSearchSubs.Caption := '...';
    btnSearchSubs.Color := clNone;
    btnSearchSubs.Font.Charset := DEFAULT_CHARSET;
    btnSearchSubs.Font.Color := clWindowText;
    btnSearchSubs.Font.Height := -12;
    btnSearchSubs.Font.Name := 'Segoe UI';
    btnSearchSubs.Font.Style := [fsBold];
    btnSearchSubs.HeightPercent := 100.000000000000000000;
    btnSearchSubs.ParentFont := False;
    btnSearchSubs.TabOrder := 1;
    btnSearchSubs.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearchSubs, Self, 'OnClick', 'btnSearchSubsClick');
    wdpStart.SetParentComponent(WebPanel1);
    wdpStart.Name := 'wdpStart';
    wdpStart.Left := 320;
    wdpStart.Top := 28;
    wdpStart.Width := 125;
    wdpStart.Height := 22;
    wdpStart.HeightStyle := ssAuto;
    wdpStart.AutoDropDown := True;
    wdpStart.BorderStyle := bsSingle;
    wdpStart.ChildOrder := 3;
    wdpStart.Color := clWhite;
    wdpStart.Date := 44908.760602962960000000;
    wdpStart.Font.Charset := DEFAULT_CHARSET;
    wdpStart.Font.Color := clWindowText;
    wdpStart.Font.Height := -12;
    wdpStart.Font.Name := 'Tahoma';
    wdpStart.Font.Style := [];
    wdpStart.ParentFont := False;
    wdpStart.Role := '';
    wdpStart.Text := '';
    wdpEnd.SetParentComponent(WebPanel1);
    wdpEnd.Name := 'wdpEnd';
    wdpEnd.Left := 320;
    wdpEnd.Top := 82;
    wdpEnd.Width := 125;
    wdpEnd.Height := 22;
    wdpEnd.HeightStyle := ssAuto;
    wdpEnd.AutoDropDown := True;
    wdpEnd.BorderStyle := bsSingle;
    wdpEnd.ChildOrder := 3;
    wdpEnd.Color := clWhite;
    wdpEnd.Date := 44908.760602962960000000;
    wdpEnd.Font.Charset := DEFAULT_CHARSET;
    wdpEnd.Font.Color := clWindowText;
    wdpEnd.Font.Height := -12;
    wdpEnd.Font.Name := 'Tahoma';
    wdpEnd.Font.Style := [];
    wdpEnd.ParentFont := False;
    wdpEnd.Role := '';
    wdpEnd.Text := '';
    btnSearch.SetParentComponent(WebPanel1);
    btnSearch.Name := 'btnSearch';
    btnSearch.Left := 134;
    btnSearch.Top := 110;
    btnSearch.Width := 121;
    btnSearch.Height := 36;
    btnSearch.Caption := 'Search';
    btnSearch.Color := clLightseagreen;
    btnSearch.Font.Charset := DEFAULT_CHARSET;
    btnSearch.Font.Color := clWindowText;
    btnSearch.Font.Height := -12;
    btnSearch.Font.Name := 'Tahoma';
    btnSearch.Font.Style := [];
    btnSearch.HeightPercent := 100.000000000000000000;
    btnSearch.MaterialGlyph := 'search';
    btnSearch.ParentFont := False;
    btnSearch.TabOrder := 4;
    btnSearch.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearch, Self, 'OnClick', 'btnSearchClick');
    eRegNo.SetParentComponent(WebPanel1);
    eRegNo.Name := 'eRegNo';
    eRegNo.Left := 8;
    eRegNo.Top := 82;
    eRegNo.Width := 161;
    eRegNo.Height := 22;
    eRegNo.ChildOrder := 12;
    eRegNo.HeightPercent := 100.000000000000000000;
    eRegNo.ReadOnly := True;
    eRegNo.WidthPercent := 100.000000000000000000;
    SetEvent(eRegNo, Self, 'OnKeyDown', 'eRegNoKeyDown');
    btnRegNo.SetParentComponent(WebPanel1);
    btnRegNo.Name := 'btnRegNo';
    btnRegNo.Left := 169;
    btnRegNo.Top := 82;
    btnRegNo.Width := 24;
    btnRegNo.Height := 22;
    btnRegNo.Caption := '...';
    btnRegNo.Color := clNone;
    btnRegNo.Font.Charset := DEFAULT_CHARSET;
    btnRegNo.Font.Color := clWindowText;
    btnRegNo.Font.Height := -12;
    btnRegNo.Font.Name := 'Segoe UI';
    btnRegNo.Font.Style := [fsBold];
    btnRegNo.HeightPercent := 100.000000000000000000;
    btnRegNo.ParentFont := False;
    btnRegNo.TabOrder := 6;
    btnRegNo.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegNo, Self, 'OnClick', 'btnRegNoClick');
    btnNew.SetParentComponent(WebPanel1);
    btnNew.Name := 'btnNew';
    btnNew.Left := 8;
    btnNew.Top := 110;
    btnNew.Width := 121;
    btnNew.Height := 36;
    btnNew.Caption := 'New';
    btnNew.Color := clBlue;
    btnNew.Font.Charset := DEFAULT_CHARSET;
    btnNew.Font.Color := clWhite;
    btnNew.Font.Height := -12;
    btnNew.Font.Name := 'Tahoma';
    btnNew.Font.Style := [fsBold];
    btnNew.HeightPercent := 100.000000000000000000;
    btnNew.ParentFont := False;
    btnNew.TabOrder := 7;
    btnNew.WidthPercent := 100.000000000000000000;
    SetEvent(btnNew, Self, 'OnClick', 'btnNewClick');
    btnClose.SetParentComponent(WebPanel1);
    btnClose.Name := 'btnClose';
    btnClose.Left := 260;
    btnClose.Top := 110;
    btnClose.Width := 121;
    btnClose.Height := 36;
    btnClose.Caption := 'Close';
    btnClose.Color := clLightseagreen;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -12;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.MaterialGlyph := 'close';
    btnClose.ParentFont := False;
    btnClose.TabOrder := 8;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    cbShowInvoiced.SetParentComponent(WebPanel1);
    cbShowInvoiced.Name := 'cbShowInvoiced';
    cbShowInvoiced.Left := 497;
    cbShowInvoiced.Top := 83;
    cbShowInvoiced.Width := 113;
    cbShowInvoiced.Height := 22;
    cbShowInvoiced.Alignment := taLeftJustify;
    cbShowInvoiced.Caption := 'Show Invoiced';
    cbShowInvoiced.ChildOrder := 13;
    cbShowInvoiced.HeightPercent := 100.000000000000000000;
    cbShowInvoiced.WidthPercent := 100.000000000000000000;
    cbShowCancel.SetParentComponent(WebPanel1);
    cbShowCancel.Name := 'cbShowCancel';
    cbShowCancel.Left := 656;
    cbShowCancel.Top := 83;
    cbShowCancel.Width := 113;
    cbShowCancel.Height := 22;
    cbShowCancel.Alignment := taLeftJustify;
    cbShowCancel.Caption := 'Show Cancelled';
    cbShowCancel.ChildOrder := 14;
    cbShowCancel.HeightPercent := 100.000000000000000000;
    cbShowCancel.WidthPercent := 100.000000000000000000;
    eDepot.SetParentComponent(WebPanel1);
    eDepot.Name := 'eDepot';
    eDepot.Left := 497;
    eDepot.Top := 28;
    eDepot.Width := 254;
    eDepot.Height := 22;
    eDepot.ChildOrder := 8;
    eDepot.HeightPercent := 100.000000000000000000;
    eDepot.ReadOnly := True;
    eDepot.WidthPercent := 100.000000000000000000;
    SetEvent(eDepot, Self, 'OnKeyDown', 'eSubsCompanyKeyDown');
    btnSearchDepot.SetParentComponent(WebPanel1);
    btnSearchDepot.Name := 'btnSearchDepot';
    btnSearchDepot.Left := 751;
    btnSearchDepot.Top := 28;
    btnSearchDepot.Width := 24;
    btnSearchDepot.Height := 22;
    btnSearchDepot.Caption := '...';
    btnSearchDepot.Color := clNone;
    btnSearchDepot.Font.Charset := DEFAULT_CHARSET;
    btnSearchDepot.Font.Color := clWindowText;
    btnSearchDepot.Font.Height := -12;
    btnSearchDepot.Font.Name := 'Segoe UI';
    btnSearchDepot.Font.Style := [fsBold];
    btnSearchDepot.HeightPercent := 100.000000000000000000;
    btnSearchDepot.ParentFont := False;
    btnSearchDepot.TabOrder := 12;
    btnSearchDepot.WidthPercent := 100.000000000000000000;
    SetEvent(btnSearchDepot, Self, 'OnClick', 'btnSearchDepotClick');
    wpBottom.SetParentComponent(WebScrollBox1);
    wpBottom.Name := 'wpBottom';
    wpBottom.Left := 0;
    wpBottom.Top := 492;
    wpBottom.Width := 949;
    wpBottom.Height := 36;
    wpBottom.Align := alBottom;
    wpBottom.ChildOrder := 2;
    wpBottom.TabOrder := 1;
    ePages.SetParentComponent(wpBottom);
    ePages.Name := 'ePages';
    ePages.Left := 60;
    ePages.Top := 5;
    ePages.Width := 52;
    ePages.Height := 22;
    ePages.Alignment := taCenter;
    ePages.ChildOrder := 4;
    ePages.HeightPercent := 100.000000000000000000;
    ePages.ReadOnly := True;
    ePages.Text := '1 of 1';
    ePages.WidthPercent := 100.000000000000000000;
    btnFirst.SetParentComponent(wpBottom);
    btnFirst.Name := 'btnFirst';
    btnFirst.Left := 13;
    btnFirst.Top := 5;
    btnFirst.Width := 24;
    btnFirst.Height := 22;
    btnFirst.Caption := '<<';
    btnFirst.Color := clNone;
    btnFirst.HeightPercent := 100.000000000000000000;
    btnFirst.TabOrder := 1;
    btnFirst.WidthPercent := 100.000000000000000000;
    SetEvent(btnFirst, Self, 'OnClick', 'btnFirstClick');
    btnNext.SetParentComponent(wpBottom);
    btnNext.Name := 'btnNext';
    btnNext.Left := 112;
    btnNext.Top := 5;
    btnNext.Width := 24;
    btnNext.Height := 22;
    btnNext.Caption := '>';
    btnNext.Color := clNone;
    btnNext.HeightPercent := 100.000000000000000000;
    btnNext.TabOrder := 2;
    btnNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnNext, Self, 'OnClick', 'btnNextClick');
    btnPrior.SetParentComponent(wpBottom);
    btnPrior.Name := 'btnPrior';
    btnPrior.Left := 36;
    btnPrior.Top := 5;
    btnPrior.Width := 24;
    btnPrior.Height := 22;
    btnPrior.Caption := '<';
    btnPrior.Color := clNone;
    btnPrior.HeightPercent := 100.000000000000000000;
    btnPrior.TabOrder := 3;
    btnPrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrior, Self, 'OnClick', 'btnPriorClick');
    btnLast.SetParentComponent(wpBottom);
    btnLast.Name := 'btnLast';
    btnLast.Left := 135;
    btnLast.Top := 5;
    btnLast.Width := 24;
    btnLast.Height := 22;
    btnLast.Caption := '>>';
    btnLast.Color := clNone;
    btnLast.HeightPercent := 100.000000000000000000;
    btnLast.TabOrder := 4;
    btnLast.WidthPercent := 100.000000000000000000;
    SetEvent(btnLast, Self, 'OnClick', 'btnLastClick');
    gEnquiry.SetParentComponent(WebScrollBox1);
    gEnquiry.Name := 'gEnquiry';
    gEnquiry.Left := 0;
    gEnquiry.Top := 153;
    gEnquiry.Width := 949;
    gEnquiry.Height := 339;
    gEnquiry.Align := alClient;
    gEnquiry.ParentDoubleBuffered := False;
    gEnquiry.DoubleBuffered := True;
    gEnquiry.TabOrder := 2;
    gEnquiry.ShowAcceleratorChar := False;
    gEnquiry.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gEnquiry.Header.VisualGrouping.Layout.Font.Height := -12;
    gEnquiry.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gEnquiry.Header.VisualGrouping.Layout.Font.Style := [];
    gEnquiry.Adapter := gdaEnquiry;
    gEnquiry.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gEnquiry.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.FilterMatchLayout.Font.Style := [];
    gEnquiry.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gEnquiry.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gEnquiry.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.BandLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.BandLayout.Font.Height := -12;
    gEnquiry.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.BandLayout.Font.Style := [];
    gEnquiry.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.FixedLayout.Font.Height := -12;
    gEnquiry.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.FixedLayout.Font.Style := [];
    gEnquiry.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gEnquiry.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gEnquiry.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.FocusedLayout.Font.Height := -12;
    gEnquiry.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.FocusedLayout.Font.Style := [];
    gEnquiry.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.GroupLayout.Font.Height := -12;
    gEnquiry.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.GroupLayout.Font.Style := [];
    gEnquiry.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.NormalLayout.Font.Height := -12;
    gEnquiry.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.NormalLayout.Font.Style := [];
    gEnquiry.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.SelectedLayout.Font.Height := -12;
    gEnquiry.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.SelectedLayout.Font.Style := [];
    gEnquiry.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gEnquiry.CellAppearance.SummaryLayout.Font.Height := -12;
    gEnquiry.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gEnquiry.CellAppearance.SummaryLayout.Font.Style := [];
    gEnquiry.ColumnCount := 10;
    gEnquiry.Columns.Clear;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order No';
      Width := 100.000000000000000000;
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Settings := [gcsEditorItems];
      Width := 100.000000000000000000;
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Fleet No';
      Settings := [gcsEditorItems];
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order Date';
      Settings := [gcsEditorItems];
      Width := 100.000000000000000000;
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.BandLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.NormalLayout.VerticalTextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      ControlAlign := gcaRight;
      Header := 'Order Litres';
      Settings := [gcsAppearance,gcsControlAlign];
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order Price';
      Settings := [gcsAppearance];
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Order Amount';
      Settings := [gcsAppearance,gcsEditorItems];
      Width := 100.000000000000000000;
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Invoice Litres';
      Settings := [gcsAppearance,gcsEditorItems];
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Depot Name';
      Width := 200.000000000000000000;
    end;
    with gEnquiry.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Company Name';
      Width := 200.000000000000000000;
    end;
    gEnquiry.Designer := False;
    gEnquiry.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gEnquiry.FilterAppearance.Font.Color := clWindowText;
    gEnquiry.FilterAppearance.Font.Height := -12;
    gEnquiry.FilterAppearance.Font.Name := 'Segoe UI';
    gEnquiry.FilterAppearance.Font.Style := [];
    gEnquiry.Icons.ExpandIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.ExpandIcon.svg');
    gEnquiry.Icons.CollapseIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.CollapseIcon.svg');
    gEnquiry.Icons.FilterIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.FilterIcon.svg');
    gEnquiry.Icons.FilterActiveIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.FilterActiveIcon.svg');
    gEnquiry.Icons.FilterClearIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.FilterClearIcon.svg');
    gEnquiry.Icons.FilterTypeIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.FilterTypeIcon.svg');
    gEnquiry.Icons.SortAscendingIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.SortAscendingIcon.svg');
    gEnquiry.Icons.SortDescendingIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.SortDescendingIcon.svg');
    gEnquiry.Icons.CloseIcon.LoadFromFile('diesel.fuelorders.enquiry.WebScrollBox1.gEnquiry.Icons.CloseIcon.svg');
    SetEvent(gEnquiry, Self, 'OnGetCellFormatting', 'gEnquiryGetCellFormatting');
    gEnquiry.RowCount := 1;
    gdaEnquiry.SetParentComponent(gEnquiry);
    gdaEnquiry.Name := 'gdaEnquiry';
    gdaEnquiry.Left := 584;
    gdaEnquiry.Top := 104;
    gdaEnquiry.Width := 26;
    gdaEnquiry.Height := 26;
    gdaEnquiry.Visible := True;
    gdaEnquiry.Columns.Clear;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'OrderNo';
      Header := 'Order No';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'RegNo';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'FleetNo';
      Header := 'Fleet No';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'OrderDate';
      Header := 'Order Date';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'OrderLiters';
      Header := 'Order Litres';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'OrderPrice';
      Header := 'Order Price';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'OrderAmount';
      Header := 'Order Amount';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'InvoicedLiters';
      Header := 'Invoice Litres';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'DepotName';
      Header := 'Depot Name';
      AutoCreated := False;
    end;
    with gdaEnquiry.Columns.Add do
    begin
      FieldName := 'SubName';
      Header := 'Company Name';
      AutoCreated := False;
    end;
    gdaEnquiry.DataSource := dsInfo;
    webconnect.SetParentComponent(Self);
    webconnect.Name := 'webconnect';
    webconnect.Connection := dmData.dbConnect;
    webconnect.Left := 160;
    webconnect.Top := 305;
    qInfo.SetParentComponent(Self);
    qInfo.Name := 'qInfo';
    qInfo.AfterOpen := qInfoAfterOpen;
    qInfo.Connection := dmData.dbConnect;
    qInfo.Left := 296;
    qInfo.Top := 281;
    qInfoOrderNo.SetParentComponent(qInfo);
    qInfoOrderNo.Name := 'qInfoOrderNo';
    qInfoOrderNo.FieldName := 'OrderNo';
    qInfoOrderDate.SetParentComponent(qInfo);
    qInfoOrderDate.Name := 'qInfoOrderDate';
    qInfoOrderDate.FieldName := 'OrderDate';
    qInfoRegNo.SetParentComponent(qInfo);
    qInfoRegNo.Name := 'qInfoRegNo';
    qInfoRegNo.FieldName := 'RegNo';
    qInfoDepotCode.SetParentComponent(qInfo);
    qInfoDepotCode.Name := 'qInfoDepotCode';
    qInfoDepotCode.FieldName := 'DepotCode';
    qInfoDepotName.SetParentComponent(qInfo);
    qInfoDepotName.Name := 'qInfoDepotName';
    qInfoDepotName.FieldName := 'DepotName';
    qInfoSubCode.SetParentComponent(qInfo);
    qInfoSubCode.Name := 'qInfoSubCode';
    qInfoSubCode.FieldName := 'SubCode';
    qInfoSubName.SetParentComponent(qInfo);
    qInfoSubName.Name := 'qInfoSubName';
    qInfoSubName.FieldName := 'SubName';
    qInfoFleetNo.SetParentComponent(qInfo);
    qInfoFleetNo.Name := 'qInfoFleetNo';
    qInfoFleetNo.FieldName := 'FleetNo';
    qInfoOrderLiters.SetParentComponent(qInfo);
    qInfoOrderLiters.Name := 'qInfoOrderLiters';
    qInfoOrderLiters.FieldName := 'OrderLiters';
    qInfoInvoicedLiters.SetParentComponent(qInfo);
    qInfoInvoicedLiters.Name := 'qInfoInvoicedLiters';
    qInfoInvoicedLiters.FieldName := 'InvoicedLiters';
    qInfoCanceled.SetParentComponent(qInfo);
    qInfoCanceled.Name := 'qInfoCanceled';
    qInfoCanceled.FieldName := 'Canceled';
    qInfoCInvoiced.SetParentComponent(qInfo);
    qInfoCInvoiced.Name := 'qInfoCInvoiced';
    qInfoCInvoiced.FieldName := 'CInvoiced';
    qInfoSInvoiced.SetParentComponent(qInfo);
    qInfoSInvoiced.Name := 'qInfoSInvoiced';
    qInfoSInvoiced.FieldName := 'SInvoiced';
    qInfoSupplierCode.SetParentComponent(qInfo);
    qInfoSupplierCode.Name := 'qInfoSupplierCode';
    qInfoSupplierCode.FieldName := 'SupplierCode';
    qInfoSupplierName.SetParentComponent(qInfo);
    qInfoSupplierName.Name := 'qInfoSupplierName';
    qInfoSupplierName.FieldName := 'SupplierName';
    qInfoSOrderNo.SetParentComponent(qInfo);
    qInfoSOrderNo.Name := 'qInfoSOrderNo';
    qInfoSOrderNo.FieldName := 'SOrderNo';
    qInfoSInvoiceNo.SetParentComponent(qInfo);
    qInfoSInvoiceNo.Name := 'qInfoSInvoiceNo';
    qInfoSInvoiceNo.FieldName := 'SInvoiceNo';
    qInfoOrderPrice.SetParentComponent(qInfo);
    qInfoOrderPrice.Name := 'qInfoOrderPrice';
    qInfoOrderPrice.FieldName := 'OrderPrice';
    qInfoOrderAmount.SetParentComponent(qInfo);
    qInfoOrderAmount.Name := 'qInfoOrderAmount';
    qInfoOrderAmount.FieldName := 'OrderAmount';
    qInfoFillType.SetParentComponent(qInfo);
    qInfoFillType.Name := 'qInfoFillType';
    qInfoFillType.FieldName := 'FillType';
    qInfoInProgress.SetParentComponent(qInfo);
    qInfoInProgress.Name := 'qInfoInProgress';
    qInfoInProgress.FieldName := 'InProgress';
    dsInfo.SetParentComponent(Self);
    dsInfo.Name := 'dsInfo';
    dsInfo.AutoEdit := False;
    dsInfo.DataSet := qInfo;
    dsInfo.Left := 264;
    dsInfo.Top := 193;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Interval := 60000;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 832;
    WebTimer1.Top := 81;
    qStatus.SetParentComponent(Self);
    qStatus.Name := 'qStatus';
    qStatus.Connection := dmData.dbConnect;
    qStatus.Left := 336;
    qStatus.Top := 288;
    qStatusOrderNo.SetParentComponent(qStatus);
    qStatusOrderNo.Name := 'qStatusOrderNo';
    qStatusOrderNo.FieldName := 'OrderNo';
    qStatusValid.SetParentComponent(qStatus);
    qStatusValid.Name := 'qStatusValid';
    qStatusValid.FieldName := 'Valid';
    qStatusSystemMessage.SetParentComponent(qStatus);
    qStatusSystemMessage.Name := 'qStatusSystemMessage';
    qStatusSystemMessage.FieldName := 'SystemMessage';
  finally
    MessageDlg.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    eSubsCompany.AfterLoadDFMValues;
    btnSearchSubs.AfterLoadDFMValues;
    wdpStart.AfterLoadDFMValues;
    wdpEnd.AfterLoadDFMValues;
    btnSearch.AfterLoadDFMValues;
    eRegNo.AfterLoadDFMValues;
    btnRegNo.AfterLoadDFMValues;
    btnNew.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    cbShowInvoiced.AfterLoadDFMValues;
    cbShowCancel.AfterLoadDFMValues;
    eDepot.AfterLoadDFMValues;
    btnSearchDepot.AfterLoadDFMValues;
    wpBottom.AfterLoadDFMValues;
    ePages.AfterLoadDFMValues;
    btnFirst.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    btnPrior.AfterLoadDFMValues;
    btnLast.AfterLoadDFMValues;
    gEnquiry.AfterLoadDFMValues;
    gdaEnquiry.AfterLoadDFMValues;
    webconnect.AfterLoadDFMValues;
    qInfo.AfterLoadDFMValues;
    qInfoOrderNo.AfterLoadDFMValues;
    qInfoOrderDate.AfterLoadDFMValues;
    qInfoRegNo.AfterLoadDFMValues;
    qInfoDepotCode.AfterLoadDFMValues;
    qInfoDepotName.AfterLoadDFMValues;
    qInfoSubCode.AfterLoadDFMValues;
    qInfoSubName.AfterLoadDFMValues;
    qInfoFleetNo.AfterLoadDFMValues;
    qInfoOrderLiters.AfterLoadDFMValues;
    qInfoInvoicedLiters.AfterLoadDFMValues;
    qInfoCanceled.AfterLoadDFMValues;
    qInfoCInvoiced.AfterLoadDFMValues;
    qInfoSInvoiced.AfterLoadDFMValues;
    qInfoSupplierCode.AfterLoadDFMValues;
    qInfoSupplierName.AfterLoadDFMValues;
    qInfoSOrderNo.AfterLoadDFMValues;
    qInfoSInvoiceNo.AfterLoadDFMValues;
    qInfoOrderPrice.AfterLoadDFMValues;
    qInfoOrderAmount.AfterLoadDFMValues;
    qInfoFillType.AfterLoadDFMValues;
    qInfoInProgress.AfterLoadDFMValues;
    dsInfo.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    qStatus.AfterLoadDFMValues;
    qStatusOrderNo.AfterLoadDFMValues;
    qStatusValid.AfterLoadDFMValues;
    qStatusSystemMessage.AfterLoadDFMValues;
  end;
end;

end.